(() => {
  // app/scripts/page-faq.js
  window.onload = () => {
    const faqTitles = document.querySelectorAll(".page-faq .faq-title");
    faqTitles.forEach((faqTitle) => {
      faqTitle.addEventListener("click", (e) => {
        let dom = e.currentTarget;
        dom.classList.toggle("show");
        let icon = dom.querySelector(".demo-icon");
        if (icon.classList.contains("icon-up")) {
          icon.classList.remove("icon-up");
          icon.classList.add("icon-down");
        } else {
          icon.classList.remove("icon-down");
          icon.classList.add("icon-up");
        }
        let faqText = dom.parentNode.querySelector(".faq-text");
        slideToggle(faqText);
      });
    });
    const faqTbTitles = document.querySelectorAll(".faq-group-style-2 .faq-tb-title");
    faqTbTitles.forEach((faqTbTitle) => {
      faqTbTitle.addEventListener("click", (e) => {
        faqTbTitles.forEach((elm) => {
          if (elm.classList.contains("active"))
            elm.classList.remove("active");
        });
        let dom = e.currentTarget;
        dom.classList.add("active");
        let tabNames = document.querySelectorAll(".faq-table-content .tab-name");
        tabNames.forEach((tabName) => {
          if (tabName.classList.contains("active"))
            tabName.classList.remove("active");
        });
        let tabNamesCurrent = document.querySelector(`.faq-table-content .tab-${dom.dataset.value}`);
        tabNamesCurrent.classList.add("active");
      });
    });
  };
  var slideToggle = (container) => {
    if (!container.classList.contains("active")) {
      container.classList.add("active");
      container.style.height = "auto";
      var height = container.offsetHeight * 1 + 70 + "px";
      container.style.height = "0px";
      setTimeout(function() {
        container.style.height = height;
      }, 0);
    } else {
      container.style.height = "0px";
      container.addEventListener("transitionend", function() {
        container.classList.remove("active");
      }, {
        once: true
      });
    }
  };
})();
